import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname } = useLocation(); // Pega a rota atual

    useEffect(() => {
    window.scrollTo(0, 0); // Quando a rota mudar, scrolla para o topo
    }, [pathname]); // Executa sempre que o pathname mudar

    return null; // Esse componente não precisa renderizar nada
}